import { googleMapsMapping } from '../google-json-structure.js';

// Example : https://api.pdok.nl/bzk/locatieserver/search/v3_1/lookup?id=adr-ff7f997dc00b0472b88ebfcc860a4a22
const pdok = {
	[ googleMapsMapping.address ]: { apiName: 'weergavenaam' },
	[ googleMapsMapping.lat ]: {
		apiName: 'centroide_ll',
		parser: ( obj ) => {
			// centroide_ll: "POINT(5.11909662 52.09321161)",
			const match = obj.centroide_ll?.match(
				/POINT\(([-\d\.]+) ([-\d\.]+)\)/
			);
			return match ? parseFloat( match[ 2 ] ) : null;
		},
	},
	[ googleMapsMapping.lng ]: {
		apiName: 'centroide_ll',
		parser: ( obj ) => {
			// centroide_ll: "POINT(5.11909662 52.09321161)",
			const match = obj.centroide_ll?.match(
				/POINT\(([-\d\.]+) ([-\d\.]+)\)/
			);
			return match ? parseFloat( match[ 1 ] ) : null;
		},
	},
	[ googleMapsMapping.zoom ]: { apiName: null, parser: 14 },
	[ googleMapsMapping.place_id ]: { apiName: 'id' },
	[ googleMapsMapping.name ]: { apiName: 'straatnaam' },
	[ googleMapsMapping.street_number ]: { apiName: 'huis_nlt' },
	[ googleMapsMapping.street_name ]: { apiName: 'straatnaam' },
	[ googleMapsMapping.city ]: { apiName: 'woonplaatsnaam' },
	[ googleMapsMapping.state ]: { apiName: 'provincienaam' },
	[ googleMapsMapping.state_short ]: { apiName: 'provincieafkorting' },
	[ googleMapsMapping.post_code ]: { apiName: 'postcode' },
	[ googleMapsMapping.country ]: { apiName: null, parser: () => 'Nederland' },
	[ googleMapsMapping.country_short ]: { apiName: null, parser: () => 'NL' },
};

export default pdok;
